var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconIdentificationBadge = function SvgIconIdentificationBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 5.375a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.956 15.445a4 4 0 1 0-5.912 0 6.6 6.6 0 0 0-1.902 1.425 1 1 0 1 0 1.466 1.36 4.625 4.625 0 0 1 6.784 0 1 1 0 1 0 1.466-1.36 6.6 6.6 0 0 0-1.902-1.425M12 10.75a2 2 0 1 0 0 4 2 2 0 0 0 0-4",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20.5 3.75A1.75 1.75 0 0 0 18.75 2H5.25A1.75 1.75 0 0 0 3.5 3.75v16.5c0 .966.784 1.75 1.75 1.75h13.5a1.75 1.75 0 0 0 1.75-1.75zM5.5 4h13v16h-13z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconIdentificationBadge;